import { render, staticRenderFns } from "./ThgCheckout.vue?vue&type=template&id=3731da00&scoped=true"
import script from "./ThgCheckout.vue?vue&type=script&lang=ts"
export * from "./ThgCheckout.vue?vue&type=script&lang=ts"
import style0 from "./ThgCheckout.vue?vue&type=style&index=0&id=3731da00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731da00",
  null
  
)

export default component.exports